import { $axios } from 'src/boot/axios';

const initialState = () => ({
  files: [],
  total: 0,
  generatedImages: {
    pixabay: [],
    unsplash: [],
  },
  folders: [],
  selectedFolder: undefined,
  selectedFiles: [],
  selectedTypes: [],
});

const getters = {};

const actions = {
  async fetchFiles({ commit, state }, params = {}) {
    const { data } = (await $axios.get(`files?${params.mimeType}`, {
      params: {
        folderGuids: [state.selectedFolder?.guid],
        perPage: params.perPage,
        page: params.page,
      },
    })).data;
    commit('setFiles', params.perPage ? [...state.files, ...data.elements] : data.elements);
    commit('setTotal', data.total);
    return data;
  },
  async fetchImageFiles({ commit }, { description, sourceType, page }) {
    const { data } = await $axios.post('files/images/find', {
      description,
      sourceType,
      page,
    });
    commit('setGeneratedImages', { data: data.data, sourceType });
  },
  async putFile({ commit, state }, { guid, payload }) {
    const { data } = await $axios.put(`files/${guid}`, payload);
    commit('setFiles', state.files.map((item) => (item.guid === guid ? data.data : item)));
  },
  async deleteFile({ commit, state }, { guid }) {
    await $axios.delete(`files/${guid}`);
    commit('setFiles', state.files.filter((item) => item.guid !== guid));
  },
  async deleteMultiple({ commit }, payload) {
    const { data } = await $axios.delete('files/delete', { data: { guids: payload } });
    commit('setSelectedFiles', []);
    return data.data;
  },
  async createFolder({ dispatch }, { payload }) {
    const { data } = await $axios.post('folders/file', payload);
    await dispatch('fetchFolders');
    return data.data.guid;
  },
  async fetchFolders({ commit }) {
    const { data } = await $axios.get('folders/file');
    commit('setFolders', data.data.elements);
  },
  async putFolder({ commit, state }, { guid, payload }) {
    const { data } = await $axios.put(`folders/file/${guid}`, payload);
    commit('setFolders', state.folders.map((item) => (item.guid === guid ? data.data : item)));
  },
  async deleteFolder({ commit, state }, { guid }) {
    await $axios.delete(`folders/file/${guid}`);
    commit('setFolders', state.folders.filter((item) => item.guid !== guid));
  },
};

const mutations = {
  setFolders(state, payload) {
    state.folders = payload;
  },
  setFiles(state, payload) {
    state.files = payload;
  },
  setTotal(state, payload) {
    state.total = payload;
  },
  setSelectedFileTypes(state, payload) {
    state.selectedTypes = payload;
  },
  setGeneratedImages(state, { data, sourceType }) {
    state.generatedImages[sourceType] = data;
  },
  setSelectedFolder(state, payload) {
    state.selectedFolder = payload;
  },
  setSelectedFiles(state, payload) {
    state.selectedFiles = payload;
  },
  addFiles(state, payload) {
    const filesArray = Array.isArray(payload) ? payload : [payload];
    state.files.unshift(...filesArray);
  },
  clear(state) {
    const clearState = initialState();
    // eslint-disable-next-line no-return-assign
    Object.keys(clearState).forEach((key) => state[key] = clearState[key]);
  },
};

export default {
  namespaced: true,
  state: initialState,
  getters,
  actions,
  mutations,
};
